import { Link, useLocation, useNavigate } from 'react-router-dom';
import { Clock, CalendarDays, Users, LogOut } from 'lucide-react';
import { toast } from 'sonner';
import { Layout } from '@/components/Layout';
import { soloFicha } from '@/lib/fichajes';

/**
 * Marco de las pantallas del registro de jornada.
 *
 * Quien SOLO ficha (trabajador, representante de los trabajadores) no ve el
 * Layout de siempre: su menú lateral pide /company-config y otros módulos que
 * el backend le cierra (fichajes_candado.py), y en el móvil le sobra. Tiene
 * una cabecera propia con sus dos o tres pantallas. Los demás roles usan el
 * Layout normal.
 */
export { soloFicha };

export function MarcoFichaje({ user, ancho = false, children }) {
  const location = useLocation();
  const navigate = useNavigate();

  if (!user) {
    return <div className="min-h-screen flex items-center justify-center text-slate-500">Cargando…</div>;
  }
  if (!soloFicha(user)) {
    return <Layout user={user}>{children}</Layout>;
  }

  const enlaces = [
    { to: '/fichar', etiqueta: 'Fichar', Icono: Clock },
    { to: '/mis-registros', etiqueta: 'Mis registros', Icono: CalendarDays },
  ];
  if (user.role === 'labor_rep') {
    enlaces.push({ to: '/equipo-fichajes', etiqueta: 'Equipo', Icono: Users });
  }

  const salir = () => {
    localStorage.removeItem('token');
    toast.success('Sesión cerrada');
    navigate('/login');
  };

  const anchura = ancho ? 'max-w-6xl' : 'max-w-xl';

  return (
    <div className="min-h-screen bg-slate-50">
      <header className="bg-white border-b border-slate-200">
        <div className={`mx-auto ${anchura} px-4 pt-3 flex items-center justify-between`}>
          <div>
            <p className="text-xs text-slate-500">Registro de jornada</p>
            <p className="font-semibold text-slate-900">{user.name}</p>
          </div>
          <button
            type="button"
            onClick={salir}
            className="flex items-center gap-1 text-sm text-slate-600 hover:text-slate-900 px-2 py-2"
          >
            <LogOut className="w-4 h-4" /> Salir
          </button>
        </div>
        <nav className={`mx-auto ${anchura} px-2 flex gap-1`}>
          {enlaces.map(({ to, etiqueta, Icono }) => {
            const activo = location.pathname === to;
            return (
              <Link
                key={to}
                to={to}
                className={`flex items-center gap-1.5 px-3 py-3 text-sm border-b-2 ${
                  activo ? 'border-slate-900 text-slate-900 font-semibold' : 'border-transparent text-slate-500'
                }`}
              >
                <Icono className="w-4 h-4" /> {etiqueta}
              </Link>
            );
          })}
        </nav>
      </header>
      <main className={`mx-auto ${anchura} px-4 py-6`}>{children}</main>
    </div>
  );
}
